import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { DemoBanner } from './components/demo/demo-banner';
import { AdminLayout } from './components/layout/admin-layout';
import { GlobalNav } from './components/layout/global-nav';
import { Footer } from './components/layout/footer';
import { CartFeedbackToast } from './components/cart/cart-feedback-toast';
import { CartErrorToast } from './components/cart/cart-error-toast';
import { PwaPromptBar } from './components/pwa/pwa-prompt-bar';
import { PricingSettingsPanel } from './features/admin/components/pricing-settings-panel';
import { ActivityBar } from '@/components/ui/activity-bar';

// Direct imports - no lazy loading to avoid 404 errors on Vercel
import CatalogPage from './pages/customer/catalog';
import HomePageV2 from './pages/customer/home-v2';
import CartPage from './pages/customer/cart';
import CheckoutPage from './pages/customer/checkout';
import MpesaPage from './pages/customer/mpesa';
import OrderConfirmationPage from './pages/customer/order-confirmation';
import ProductDetailsPage from './pages/customer/product-details';
import AdminDashboardPage from './pages/admin/dashboard';
import AdminLoginPage from './pages/admin/login';
import AdminSetupPage from './pages/admin/setup';
import AdminRegisterPage from './pages/admin/register';
import AdminOrdersPage from './pages/admin/orders';
import AdminProductsPage from './pages/admin/products';
import BranchConfigPage from './pages/admin/branch-config';
import SettingsPage from './pages/admin/settings';
import RidersPage from './pages/admin/riders';
import AdminsPage from './pages/admin/admins';
import RiderPortalPage from './pages/rider/portal';
import { trackSiteVisit } from '@/features/analytics/api/visits';

function App() {
  const location = useLocation();
  
  useEffect(() => {
    console.log('[Router] Navigation to:', location.pathname);
    // Check if current admin route is defined
    const knownAdminRoutes = ['/admin', '/admin/orders', '/admin/branches', '/admin/login', '/admin/settings', '/admin/riders', '/admin/products', '/admin/admins', '/admin/pricing'];
    const isKnownRoute = knownAdminRoutes.some(path => 
      location.pathname === path || location.pathname.startsWith(path + '/')
    );
    if (location.pathname.startsWith('/admin') && !isKnownRoute) {
      console.warn('[Router] WARNING: Route', location.pathname, 'not defined - will redirect to /admin');
    }
  }, [location.pathname]);

  useEffect(() => {
    void trackSiteVisit(location.pathname);
  }, [location.pathname]);

  const showClientChrome = !location.pathname.startsWith('/admin');
  const showCustomerFooter = !location.pathname.startsWith('/admin') && !location.pathname.startsWith('/rider');
  
  return (
    <div className="min-h-screen bg-brand-50">
      <ActivityBar />
      {showClientChrome && <GlobalNav />}
      {location.pathname.startsWith('/admin') && <PwaPromptBar />}
      {showClientChrome && <DemoBanner />}
      <CartFeedbackToast />
      <CartErrorToast />
        <Routes>
          {/* Customer Routes */}
          <Route path="/" element={<HomePageV2 />} />
          <Route path="/v2" element={<HomePageV2 />} />
          <Route path="/test-home" element={<HomePageV2 />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/products/:productId" element={<ProductDetailsPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/mpesa" element={<MpesaPage />} />
          <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
          
          {/* Admin Routes - with Sidebar Layout } */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/setup" element={<AdminSetupPage />} />
          <Route path="/admin/register" element={<AdminRegisterPage />} />
          <Route path="/admin" element={<AdminLayout><AdminDashboardPage /></AdminLayout>} />
          <Route path="/admin/orders" element={<AdminLayout><AdminOrdersPage /></AdminLayout>} />
          <Route path="/admin/products" element={<AdminLayout><AdminProductsPage /></AdminLayout>} />
          <Route path="/admin/branches" element={<AdminLayout><BranchConfigPage /></AdminLayout>} />
          <Route path="/admin/settings" element={<AdminLayout><SettingsPage /></AdminLayout>} />
          <Route path="/admin/pricing" element={<AdminLayout><PricingSettingsPanel /></AdminLayout>} />
          <Route path="/admin/riders" element={<AdminLayout><RidersPage /></AdminLayout>} />
          <Route path="/admin/admins" element={<AdminLayout><AdminsPage /></AdminLayout>} />
          <Route path="/admin/*" element={<AdminLayout><AdminDashboardPage /></AdminLayout>} />
          
          {/* Rider Routes */}
          <Route path="/rider" element={<RiderPortalPage />} />
          <Route path="/rider/*" element={<RiderPortalPage />} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      {showCustomerFooter && <Footer />}
    </div>
  );
}

export default App;
